<ngx-awesome-uploader
    [adapter]="adapter"
    [enableCropper]="true"
    [enableAutoUpload]="true"
    [draggable]="true"
    [uploadType]="fileMode"
    [fileMaxSize]="fileSize"
    (uploadSuccess)="onUploadSuccess($event)"
    (removeSuccess)="onRemoveSuccess($event)"
    [fileExtensions]="['pdf', 'jpg', 'jpeg', 'png', 'mp4', '.csv']"
    (validationError)="onValidationError($event)"
    [showPreviewContainer]="true"
    (fileAdded)="onFileAdded($event)"
    (fileRemoved)="onFileRemoved($event)"
    [accept]="fileTypes"
    [cropperOptions]="cropperOptions"
  >
  </ngx-awesome-uploader>
